import { Box, Typography, Link } from '@mui/material';
import React from 'react';
import CancelButton from './CancelButton';
import SectionTitle from './SectionTitle';
import SubmitButton from './SubmitButton';
import { color, space } from '../../shared/ui';

export const colors = { background: color.white, primary: color.brand, text: color.black };

export default function AuthForm({
  children,
  disableCancel,
  disableSubmit,
  isLoading,
  linkButtonText,
  linkLabel,
  onCancel = () => {},
  onLinkButtonClick = () => {},
  onSubmit = () => {},
  sectionTitle,
  submitText = '',
  subtitle,
}) {
  return (
    <form onSubmit={onSubmit}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          pt: space[20],
          gap: 3,
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <SectionTitle subtitle={subtitle}>{sectionTitle}</SectionTitle>
        {children}
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
        <CancelButton onClick={onCancel} disabled={isLoading || disableCancel} />
        <SubmitButton disabled={isLoading || disableSubmit}>{submitText}</SubmitButton>
      </Box>
      {!!linkButtonText && (
        <Box sx={{ mt: 10, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ mb: 1, fontSize: 16 }}>
            {linkLabel}
          </Typography>
          <Link
            component="button"
            onClick={onLinkButtonClick}
            sx={{
              color: colors.primary,
              fontWeight: 'bold',
              textTransform: 'uppercase',
              fontSize: 14,
            }}
          >
            {linkButtonText}
          </Link>
        </Box>
      )}
    </form>
  );
}
